export class BaseRestResource {

  Constructor = BaseRestResource;

  /**
   * @constructor
   * @param {BaseHttpResource} httpResource
   * @param {string} resourceUrl
   * @param options
   */
  constructor(private httpResource,
              private resourceUrl,
              private options?) {
  }

  create(body, options) {
    return this.httpResource.post(this.resourceUrl, body, this.createOptions(options));
  }

  update(body, options) {
    return this.httpResource.put(this.resourceUrl, body, this.createOptions(options));
  }

  patch(body, options) {
    return this.httpResource.patch(this.resourceUrl, body, this.createOptions(options));
  }

  get(body, options) {
    return this.httpResource.get(this.resourceUrl, body, this.createOptions(options));
  }

  delete(options) {
    return this.httpResource.delete(this.resourceUrl, this.createOptions(options));
  }

  child(...routeParts) {
    const baseUrl = this.resolveChildUrl(routeParts);
    return new this.Constructor(this.httpResource, baseUrl, this.options);
  }

  setBaseUrl(baseUrl: string): void {
    this.resourceUrl = baseUrl;
  }

  /**
   * @
   * @param routeParts
   * @returns {string}
   */
  resolveChildUrl(routeParts): string {
    return routeParts.reduce((resultUrl, routePart) =>
      `${resultUrl}/${routePart}`, this.resourceUrl);
  }

  /**
   * @
   * @param options
   * @returns {*}
   */
  createOptions(options) {
    return Object.assign({}, this.options, options);
  }
}
